// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verticalTimeline_container__4\\+3WB {
  height: 90vh;
  overflow: scroll;
  width: fit-content;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  transition: all 0.4s;
  margin-right: 10px; }

.verticalTimeline_header__4S9pt {
  position: absolute;
  top: -12px;
  height: 0;
  width: 100%;
  height: 35px;
  background-color: #f5f5f5;
  z-index: 5; }

.verticalTimeline_timelineWrapper__9N0om {
  height: 100%;
  display: flex;
  overflow: auto;
  transition: all 0.4s; }

.verticalTimeline_timelineContainer__pHb0l {
  position: relative; }

.verticalTimeline_wrapper__OPEZn {
  max-width: 100%;
  height: fit-content;
  position: relative;
  overflow-y: hidden;
  overflow-x: scroll;
  transition: all 0.4s;
  transform: scaleY(-1); }
  .verticalTimeline_wrapper__OPEZn * {
    transition: all 0.4s; }
  .verticalTimeline_wrapper__OPEZn .verticalTimeline_content__skFh4 {
    transform: scaleY(-1); }

.verticalTimeline_gorilla__W-kyu {
  width: calc(100vw - 600px);
  display: flex;
  align-items: center;
  justify-content: center; }

.verticalTimeline_noData__puqjy {
  display: flex;
  justify-content: center;
  width: calc(100vw - 600px);
  transform: scaleY(-1);
  line-height: 200%; }

.verticalTimeline_datetime__RK8I1 {
  margin-top: 16px;
  width: 100px;
  z-index: 1; }

.verticalTimeline_prev__CC0ic {
  position: absolute;
  top: 10px;
  left: 0px;
  z-index: 2;
  cursor: pointer;
  transform: rotate(180deg);
  background-color: #f5f5f5;
  z-index: 101; }

.verticalTimeline_next__l-ZuP {
  position: absolute;
  top: 10px;
  right: 00px;
  width: 100px;
  z-index: 2;
  cursor: pointer;
  background-color: #f5f5f5;
  z-index: 101; }

.verticalTimeline_arrow__8U0u5 {
  opacity: 0.7; }

.verticalTimeline_arrow__8U0u5:hover {
  opacity: 1; }

.verticalTimeline_text__BGOhm {
  text-align: center;
  font-size: 10px;
  word-wrap: break-word;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 0.15px;
  padding: 0 5px;
  color: #444343; }

.verticalTimeline_tooltip__MhZk\\+ {
  position: relative;
  z-index: 100;
  transition: all 0.4s;
  font-size: 10px; }

.verticalTimeline_tooltip__MhZk\\+::before {
  white-space: nowrap;
  position: absolute;
  top: 25px;
  left: 15px;
  padding: 5px 8px;
  background: #ffffff;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #444343;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s;
  border-radius: 6px;
  z-index: 100;
  z-index: 100; }

.verticalTimeline_tooltip__MhZk\\+:hover::before {
  opacity: 1;
  z-index: 100; }
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersViewD3/components/verticalTimeline.module.scss"],"names":[],"mappings":"AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB,EAAA;EAPvB;IASI,oBAAoB,EAAA;EATxB;IAYI,qBAAqB,EAAA;;AAIzB;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB,EAAA;;AAEnB;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,YAAY,EAAA;;AAEd;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;;AAEd;EACE,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,eAAe;EAEf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,cAAc,EAAA;;AAEhB;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EAEnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,UAAU;EACV,YAAY,EAAA","sourcesContent":["\n.container {\n  height: 90vh;\n  overflow: scroll;\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition: all 0.4s;\n  margin-right: 10px;\n}\n\n.header {\n  position: absolute;\n  top: -12px;\n  height: 0;\n  width: 100%;\n  height: 35px;\n  background-color: #f5f5f5;\n  z-index: 5;\n}\n\n.timelineWrapper {\n  height: 100%;\n  display: flex;\n  overflow: auto;\n  transition: all 0.4s;\n}\n\n.timelineContainer{\n  position: relative;\n}\n\n.wrapper {\n  max-width: 100%;\n  height: fit-content;\n  position: relative;\n  overflow-y: hidden;\n  overflow-x: scroll;\n  transition: all 0.4s;\n  transform: scaleY(-1);\n  * {\n    transition: all 0.4s;\n  }\n  .content{\n    transform: scaleY(-1);\n  }\n}\n\n.gorilla {\n  width: calc(100vw - 600px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.noData{\n  display: flex;\n  justify-content: center;\n  width: calc(100vw - 600px);\n  transform: scaleY(-1);\n  line-height: 200%;\n}\n.datetime {\n  margin-top: 16px;\n  width: 100px;\n  z-index: 1;\n}\n\n.prev {\n  position: absolute;\n  top: 10px;\n  left: 0px;\n  z-index: 2;\n  cursor: pointer;\n  transform: rotate(180deg);\n  background-color: #f5f5f5;\n  z-index: 101;\n}\n.next {\n  position: absolute;\n  top: 10px;\n  right: 00px;\n  width: 100px;\n  z-index: 2;\n  cursor: pointer;\n  background-color: #f5f5f5;\n  z-index: 101;\n}\n\n.arrow {\n  opacity: 0.7;\n}\n.arrow:hover {\n  opacity: 1;\n}\n\n.text {\n  text-align: center;\n  font-size: 10px;\n  // white-space: nowrap; /* Отменяем перенос текста */\n  word-wrap: break-word;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.25;\n  letter-spacing: 0.15px;\n  padding: 0 5px;\n  color: #444343;\n}\n.tooltip {\n  position: relative;\n  z-index: 100;\n  transition: all 0.4s;\n  font-size: 10px;\n}\n\n.tooltip::before {\n  white-space: nowrap;\n  // content: attr(titles);\n  position: absolute;\n  top: 25px;\n  left: 15px;\n  padding: 5px 8px;\n  background: #ffffff;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: #444343;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.5s;\n  border-radius: 6px;\n  z-index: 100;\n  z-index: 100;\n}\n\n.tooltip:hover::before {\n  opacity: 1;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `verticalTimeline_container__4+3WB`,
	"header": `verticalTimeline_header__4S9pt`,
	"timelineWrapper": `verticalTimeline_timelineWrapper__9N0om`,
	"timelineContainer": `verticalTimeline_timelineContainer__pHb0l`,
	"wrapper": `verticalTimeline_wrapper__OPEZn`,
	"content": `verticalTimeline_content__skFh4`,
	"gorilla": `verticalTimeline_gorilla__W-kyu`,
	"noData": `verticalTimeline_noData__puqjy`,
	"datetime": `verticalTimeline_datetime__RK8I1`,
	"prev": `verticalTimeline_prev__CC0ic`,
	"next": `verticalTimeline_next__l-ZuP`,
	"arrow": `verticalTimeline_arrow__8U0u5`,
	"text": `verticalTimeline_text__BGOhm`,
	"tooltip": `verticalTimeline_tooltip__MhZk+`
};
export default ___CSS_LOADER_EXPORT___;
